import { Component, Input, OnInit } from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { FieldTypeNumberComponent } from '../../../shared/components/field-type-number/field-type-number.component';
import { FieldTypeListSimpleComponent } from '../../../shared/components/field-type-list/field-type-list-simple/field-type-list-simple.component';
import { FormsModule } from '@angular/forms';
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";

@Component({
    selector: 'customize-field-money',
    templateUrl: './customize-field-money.component.html',
    standalone: true,
    imports: [FormsModule, FieldTypeListSimpleComponent, FieldTypeNumberComponent, CustomizeFieldsSwitchFormComponent]
})
export class CustomizeFieldMoneyComponent implements OnInit  {
  customizeFieldMoney: any ={
    moneyTypeInfo: {
      label: this.translate.instant('customize.coin'),
      required: true
    },
    defaultValueInfo: {
      label: this.translate.instant('customize.default-value'),
      decimals: 2
    }
  }

  constructor(
    private translate: AfTranslateFactory,
    private apiService: ApiServiceService,
    private commonUtilsService: CommonUtilsService) { }

  @Input() field: any = null;
  @Input() isPrivate: any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept: any = null;
  @Input() previewMode: boolean = false;

  ngOnInit(){
    this.customizeFieldMoney.field = this.field;
    if(this.previewMode || (this.concept?.poll && this.concept?.disabled)){
      this.customizeFieldMoney.moneyTypeInfo.noEditable = true;
      this.customizeFieldMoney.defaultValueInfo.noEditable = true;
    }
    this.getCurrencies();
  }

  getCurrencies(){
    this.apiService.get('currencies')
        .then((data:any)=>{
            this.customizeFieldMoney.moneyTypeList = this.commonUtilsService.editList(data, 'currencyId', 'name')
        }, (errorData:any)=>{})
  }

  itemSelected(e:any, item:any){
      this.customizeFieldMoney.field[item] = e.newValue;
  }

  validateSave() {
    if(!this.customizeFieldMoney.field.currencyId){
      this.customizeFieldMoney.moneyTypeInfo.error = true;
      return false;
    }
    return true;
  }
}
